export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_ITEMS_PER_PAGE: 24,
  MAXIMUM_PAGE_SIZE: 100,
}
